import React from 'react';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { useHolidayTheme } from '../../../contexts/holiday-theme-context';

export const HolidayToggleButton: React.FC = () => {
  const { isHolidaySeason, setIsManuallyEnabled, isManuallyEnabled } = useHolidayTheme();

  const handleToggle = () => {
    if (isManuallyEnabled) {
      // Currently manually enabled, disable it
      setIsManuallyEnabled(false);
    } else {
      // Currently disabled or auto, enable it
      setIsManuallyEnabled(true);
    }
  };

  return (
    <Tooltip title={isHolidaySeason ? 'Disable holiday theme' : 'Enable holiday theme'}>
      <IconButton
        onClick={handleToggle}
        sx={{
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
        }}
        aria-label={isHolidaySeason ? 'Disable holiday theme' : 'Enable holiday theme'}
      >
        <Typography
          sx={{
            fontSize: '1.5rem',
            lineHeight: 1,
            opacity: isHolidaySeason ? 1 : 0.6,
            transition: 'opacity 0.3s ease',
          }}
        >
          🎄
        </Typography>
      </IconButton>
    </Tooltip>
  );
};


